module.exports = __webpack_public_path__ + "img/25f.7d9d05e7.png";